import { render, staticRenderFns } from "./MetricIcon.vue?vue&type=template&id=6ca04a4f"
import script from "./MetricIcon.vue?vue&type=script&lang=js"
export * from "./MetricIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports